import {
  fetchPlacements as fetchPlacementsApi,
  createPlacement as createPlacementApi,
  updatePlacement as updatePlacementApi,
  deletePlacement as deletePlacementApi,
} from '../../shared/utils/api';
import {
  FETCH_PLACEMENTS_REQUEST,
  FETCH_PLACEMENTS_SUCCESS,
  FETCH_PLACEMENTS_FAIL,
  CREATE_PLACEMENT_REQUEST,
  CREATE_PLACEMENT_SUCCESS,
  CREATE_PLACEMENT_FAIL,
  UPDATE_PLACEMENT_REQUEST,
  UPDATE_PLACEMENT_SUCCESS,
  UPDATE_PLACEMENT_FAIL,
  DELETE_PLACEMENT_REQUEST,
  DELETE_PLACEMENT_SUCCESS,
  DELETE_PLACEMENT_FAIL,
} from '../../store/types';
import { UI_MESSAGES } from '../../shared/constants';
import { extractContractError } from  '@bafkal/ui-shared/utils';

export const fetchPlacements = (page = 1) => async (dispatch) => {
  dispatch({ type: FETCH_PLACEMENTS_REQUEST });
  try {
    const data = await fetchPlacementsApi(page);
    dispatch({ type: FETCH_PLACEMENTS_SUCCESS, payload: data });
    return data;
  } catch (err) {
    const contractError = extractContractError(err, UI_MESSAGES.PLACEMENT.FETCH_FAILED);
    dispatch({ type: FETCH_PLACEMENTS_FAIL, payload: contractError });
    throw err;
  }
};

export const createPlacement = (data, idempotencyKey) => async (dispatch) => {
  dispatch({ type: CREATE_PLACEMENT_REQUEST });
  try {
    const result = await createPlacementApi(data, idempotencyKey);
    dispatch({ type: CREATE_PLACEMENT_SUCCESS, payload: result });
    return result;
  } catch (err) {
    const contractError = extractContractError(err, UI_MESSAGES.PLACEMENT.CREATE_FAILED);
    dispatch({ type: CREATE_PLACEMENT_FAIL, payload: contractError });
    throw err;
  }
};

export const updatePlacement = (id, data) => async (dispatch) => {
  dispatch({ type: UPDATE_PLACEMENT_REQUEST });
  try {
    const result = await updatePlacementApi(id, data);
    dispatch({ type: UPDATE_PLACEMENT_SUCCESS, payload: result });
    return result;
  } catch (err) {
    const contractError = extractContractError(err, UI_MESSAGES.PLACEMENT.UPDATE_FAILED);
    dispatch({ type: UPDATE_PLACEMENT_FAIL, payload: contractError });
    throw err;
  }
};

export const deletePlacement = (id) => async (dispatch) => {
  dispatch({ type: DELETE_PLACEMENT_REQUEST });
  try {
    await deletePlacementApi(id);
    dispatch({ type: DELETE_PLACEMENT_SUCCESS, payload: id });
    return id;
  } catch (err) {
    const contractError = extractContractError(err, UI_MESSAGES.PLACEMENT.DELETE_FAILED);
    dispatch({ type: DELETE_PLACEMENT_FAIL, payload: contractError });
    throw err;
  }
};
